import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/(app)/marketplace/marketplace-client.tsx");
